import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PartnerState } from ".";

const initialState: PartnerState = {
  tab: 0,
  partners: [],
  partner: null,
  loading: false,
};

export const partnerSlice = createSlice({
  name: "partner",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setTab: (state, action: PayloadAction<number>) => {
      state.tab = action.payload;
    },
    setPartner: (state, action: PayloadAction<any>) => {
      state.partner = action.payload;
    },
    addPartner: (state, action) => {
      state.partners.unshift(action.payload);
    },
    updatePartner: (state, action) => {
      const booking = action.payload;
      state.partner = booking;
    },
    setPartners: (state, action) => {
      state.partners = action.payload;
    },
  },
});

const partnerReducer = partnerSlice.reducer;

export const partnerActions = partnerSlice.actions;
export default partnerReducer;
